import { useEffect, useRef, useState } from 'react';

export default function WhyChooseUs() {
    const whyChooseSectionRef = useRef(null);
    const [animationFrame, setAnimationFrame] = useState(null);
    const [isAnimated, setIsAnimated] = useState(false);

    const updateAnimation = () => {
        const whyChooseSection = whyChooseSectionRef.current;

        if (whyChooseSection) {
            const sectionTop = whyChooseSection.offsetTop;
            const sectionHeight = whyChooseSection.offsetHeight;
            const windowTop = window.scrollY;
            const windowHeight = window.innerHeight;

            // Calculate how much of the section is visible
            const sectionVisible = windowTop + windowHeight - sectionTop;
            const sectionProgress = Math.max(0, Math.min(1, sectionVisible / (sectionHeight * 0.6)));

            // Progressive animation based on scroll position
            const currentMaxWidth = 500 + (sectionProgress * (window.innerWidth - 500)); // 500 to full width
            const currentBorderRadius = 40 - (sectionProgress * 40); // 40 to 0
            const currentScale = 0.8 + (sectionProgress * 0.2); // 0.8 to 1
            const currentOpacity = 0.3 + (sectionProgress * 0.7); // 0.3 to 1

            whyChooseSection.style.maxWidth = currentMaxWidth + 'px';
            whyChooseSection.style.borderRadius = currentBorderRadius + 'px';
            whyChooseSection.style.transform = `scale(${currentScale})`;
            whyChooseSection.style.opacity = currentOpacity;

            // Add animate class when fully visible
            if (sectionProgress >= 1) {
                setIsAnimated(true);
            } else {
                setIsAnimated(false);
            }
        }
    };

    const throttledUpdate = () => {
        if (animationFrame) {
            cancelAnimationFrame(animationFrame);
        }
        const newFrame = requestAnimationFrame(updateAnimation);
        setAnimationFrame(newFrame);
    };

    useEffect(() => {
        window.addEventListener('scroll', throttledUpdate);

        // Update on page load
        updateAnimation();

        return () => {
            window.removeEventListener('scroll', throttledUpdate);
            if (animationFrame) {
                cancelAnimationFrame(animationFrame);
            }
        };
    }, [animationFrame]);

    return (
        <section
            ref={whyChooseSectionRef}
            id="why-choose-us-section"
            className={isAnimated ? 'animate' : ''}
        >
            <div className="why-choose-container">
                <div className="why-choose-content">
                    <div className="why-choose-left">
                        <h2 className="section-title">Our Facilities</h2>
                    </div>

                    <div className="why-choose-right">
                        <div className="why-choose-list">
                            {[
                                "Air Conditioned Classrooms",
                                "Fully equipped Classrooms",
                                "Hygienic & Clean Toilets",
                                "Hygienic & Clean Classrooms",
                                "Water Area",
                                "CCTV Camera in every room for Students Safety",
                                "Medical Kit and Emergency Medical Assistance",
                                "SPractice Area Provided : Monday, Wednesday, Friday (3pm to 7pm)",
                                "Teacher Support during Practice Sessions",
                                "Professional Studio Recording for Students",
                                "Instruments Provided in Class",
                                "Music Library with Books, Sheet Music",
                                "Comfortable Waiting Area for Students/Parents",
                                "Free WiFi",
                                "Student Portfolio Building Space"
                            ].map((text, index) => (
                                <div className="why-choose-item" key={index}>
                                    <span className="item-text">{text}</span>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
